import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromFilterFields from '../reducers/filter-fields.reducer';

export const getFilterFieldsState = createSelector(fromFeature.getEventState, (state: fromFeature.EventState) => state.filterFields);

export const getFilterFields = createSelector(getFilterFieldsState, fromFilterFields.getFilterFields);
export const getFilterFieldsLoading = createSelector(getFilterFieldsState, fromFilterFields.getFilterFieldsLoading);
export const getFilterFieldsLoaded = createSelector(getFilterFieldsState, fromFilterFields.getFilterFieldsLoaded);
export const getFilterFieldsError = createSelector(getFilterFieldsState, fromFilterFields.getFilterFieldsError);
